import React, { useRef, useState } from 'react';

const linkedinUrl = 'https://www.linkedin.com/in/krish-gupta-b173b6172/';
const githubUrl = 'https://github.com/Kilo-zolo/';
const contactEmail = 'krish.gupta@zohtek.com';
const contactPhone = '+61 483 815 547';

const labelStyle = {
  fontFamily: 'var(--zk-mono)',
  fontSize: '11px',
  letterSpacing: '0.1em',
  color: 'rgba(232,238,240,0.5)',
  textTransform: 'uppercase',
};

const Contact = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [website, setWebsite] = useState('');
  const [status, setStatus] = useState('idle');
  const [sentName, setSentName] = useState('');
  const [sentEmail, setSentEmail] = useState('');
  const formLoadedAt = useRef(Date.now());

  const onSubmit = async (e) => {
    e.preventDefault();
    if (status === 'sending') return;
    setStatus('sending');
    try {
      const res = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: name.trim(),
          email: email.trim(),
          message: message.trim(),
          website,
          formLoadedAt: formLoadedAt.current,
        }),
      });
      if (res.ok) {
        setSentName(name.trim() || 'there');
        setSentEmail(email.trim());
        setStatus('sent');
        return;
      }
      setStatus(res.status === 429 ? 'rate_limited' : 'error');
    } catch (err) {
      setStatus('error');
    }
  };

  const sent = status === 'sent';

  return (
    <section
      id="contact"
      style={{
        background: 'linear-gradient(180deg, rgba(255,62,165,0.06) 0%, rgba(56,224,255,0.045) 100%)',
        borderTop: '1px solid rgba(255,255,255,0.06)',
      }}
    >
      <div
        className="zk-section-pad zk-section-gutter"
        style={{ maxWidth: '680px', margin: '0 auto', padding: '120px 56px', textAlign: 'center' }}
      >
        <span style={{ fontFamily: 'var(--zk-mono)', fontSize: '12px', letterSpacing: '0.2em', color: '#38e0ff' }}>
          &gt; init: contact
        </span>
        <h2
          style={{
            margin: '18px 0 16px',
            fontSize: 'clamp(32px, 4vw, 50px)',
            fontWeight: 600,
            letterSpacing: '-0.02em',
            lineHeight: 1.06,
          }}
        >
          Have a data problem worth solving?
        </h2>
        <p
          style={{
            margin: '0 auto 44px',
            maxWidth: '520px',
            fontSize: '17px',
            lineHeight: 1.6,
            color: 'rgba(232,238,240,0.74)',
            textWrap: 'pretty',
          }}
        >
          Tell me what you are trying to figure out. If Zohtek is a fit, I will say so; if it's not, I will point you somewhere better.
        </p>

        {sent ? (
          <div
            style={{
              padding: '48px 32px',
              background: 'rgba(255,255,255,0.02)',
              border: '1px solid rgba(56,224,255,0.35)',
              borderRadius: '4px',
              textAlign: 'left',
            }}
          >
            <div style={{ fontSize: '18px', fontWeight: 600, color: '#38e0ff', marginBottom: '10px' }}>
              Thanks, {sentName}.
            </div>
            <p style={{ margin: 0, fontSize: '15px', lineHeight: 1.6, color: 'rgba(232,238,240,0.74)' }}>
              Your note is on its way. I will get back to you at {sentEmail} shortly.
            </p>
          </div>
        ) : (
          <form
            onSubmit={onSubmit}
            style={{ display: 'flex', flexDirection: 'column', gap: '16px', textAlign: 'left' }}
            noValidate
          >
            <div
              aria-hidden="true"
              style={{
                position: 'absolute',
                left: '-10000px',
                top: 'auto',
                width: '1px',
                height: '1px',
                overflow: 'hidden',
              }}
            >
              <label>
                Website (leave blank)
                <input
                  type="text"
                  tabIndex={-1}
                  autoComplete="off"
                  name="website"
                  value={website}
                  onChange={(e) => setWebsite(e.target.value)}
                />
              </label>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }} className="zk-grid-engagement">
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <label style={labelStyle} htmlFor="zk-name">Name</label>
                <input
                  id="zk-name"
                  className="zk-input"
                  type="text"
                  placeholder="Your name"
                  required
                  minLength={1}
                  maxLength={120}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  autoComplete="name"
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <label style={labelStyle} htmlFor="zk-email">Email</label>
                <input
                  id="zk-email"
                  className="zk-input"
                  type="email"
                  placeholder="you@company.com"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="email"
                />
              </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <label style={labelStyle} htmlFor="zk-message">What are you trying to solve?</label>
              <textarea
                id="zk-message"
                className="zk-textarea"
                rows={4}
                placeholder="A few sentences is plenty."
                required
                minLength={10}
                maxLength={5000}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
            </div>

            <button
              type="submit"
              className="zk-submit"
              disabled={status === 'sending'}
              style={{ marginTop: '6px' }}
            >
              {status === 'sending' ? '[ SENDING… ]' : '[ START_A_CONVERSATION ]'}
            </button>

            {(status === 'error' || status === 'rate_limited') && (
              <div
                role="alert"
                style={{
                  marginTop: '8px',
                  padding: '14px 16px',
                  border: '1px solid rgba(255,62,165,0.45)',
                  background: 'rgba(255,62,165,0.06)',
                  borderRadius: '2px',
                  fontSize: '14px',
                  color: 'rgba(232,238,240,0.88)',
                  lineHeight: 1.5,
                }}
              >
                {status === 'rate_limited'
                  ? 'Too many submissions from this network in the last hour. '
                  : "Couldn't send right now. "}
                Please email <a href={`mailto:${contactEmail}`} style={{ color: '#38e0ff', textDecoration: 'underline' }}>{contactEmail}</a> directly.
              </div>
            )}
          </form>
        )}

        <div
          style={{
            marginTop: '40px',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '10px 20px',
            fontFamily: 'var(--zk-mono)',
            fontSize: '12.5px',
            color: 'rgba(232,238,240,0.6)',
          }}
        >
          <a href={`mailto:${contactEmail}`} style={{ color: '#38e0ff', textDecoration: 'none' }}>
            {contactEmail}
          </a>
          <span style={{ opacity: 0.35 }}>/</span>
          <a href={`tel:${contactPhone.replace(/\s/g, '')}`} style={{ color: 'rgba(232,238,240,0.7)', textDecoration: 'none' }}>
            {contactPhone}
          </a>
          <span style={{ opacity: 0.35 }}>/</span>
          <a href={linkedinUrl} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="zk-social">
            <svg width="19" height="19" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20.45 20.45h-3.56v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.35V9h3.42v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.07 2.07 0 1 1 0-4.14 2.07 2.07 0 0 1 0 4.14zM7.12 20.45H3.56V9h3.56v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.73v20.54C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.73V1.73C24 .77 23.2 0 22.22 0z" />
            </svg>
          </a>
          <a href={githubUrl} target="_blank" rel="noopener noreferrer" aria-label="GitHub" className="zk-social">
            <svg width="19" height="19" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 .5C5.37.5 0 5.78 0 12.29c0 5.21 3.44 9.63 8.21 11.19.6.11.82-.25.82-.56 0-.28-.01-1.02-.02-2-3.34.71-4.04-1.58-4.04-1.58-.55-1.37-1.34-1.73-1.34-1.73-1.09-.73.08-.72.08-.72 1.2.08 1.84 1.21 1.84 1.21 1.07 1.8 2.81 1.28 3.5.98.11-.76.42-1.28.76-1.57-2.67-.3-5.47-1.31-5.47-5.83 0-1.29.47-2.34 1.24-3.17-.12-.3-.54-1.52.12-3.17 0 0 1.01-.32 3.3 1.21a11.5 11.5 0 0 1 3-.4c1.02 0 2.05.14 3 .4 2.29-1.53 3.3-1.21 3.3-1.21.66 1.65.24 2.87.12 3.17.77.83 1.24 1.88 1.24 3.17 0 4.53-2.81 5.53-5.49 5.82.43.37.81 1.1.81 2.22 0 1.6-.01 2.89-.01 3.28 0 .31.21.68.83.56C20.56 21.91 24 17.5 24 12.29 24 5.78 18.63.5 12 .5z" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Contact;
